import { Icon } from '@chakra-ui/react';

export const RogueSvg = ({
  size = 6,
  theme = 'light',
}: {
  size?: number;
  theme?: 'light' | 'dark';
}): JSX.Element => {
  const color = theme === 'light' ? 'white' : 'black';

  return (
    <Icon
      fill={color}
      height={size}
      viewBox="0 0 18 11"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_548_4792)">
        <path d="M0.973022 6.14249C0.986734 4.04895 2.1842 2.70899 4.02153 1.91527C5.02703 1.48051 6.14223 1.20628 7.23686 1.05467C9.49924 0.738074 11.7571 0.862928 13.9235 1.64773C15.5803 2.2497 16.876 3.253 17.3627 5.01211C17.9683 7.19929 16.6772 9.67409 14.5542 10.4165C13.1259 10.9159 11.7182 10.4946 10.811 9.29506C10.5642 8.96732 10.3425 8.61728 10.0911 8.29177C9.61122 7.6675 8.92107 7.66081 8.42061 8.27616C8.25607 8.47905 8.1121 8.69978 7.9727 8.9205C6.37304 11.4845 3.36338 10.8067 2.01281 9.13677C1.31124 8.26279 0.989019 7.35982 0.973022 6.14249ZM5.83829 4.43243C5.00875 4.41236 4.11294 4.81145 3.69931 5.42458C3.58962 5.58733 3.57134 5.94183 3.68103 6.09344C4.60655 7.37097 6.65641 7.40887 7.67105 6.20046C7.93385 5.88832 7.92243 5.60963 7.6482 5.31533C7.13859 4.77132 6.50558 4.48594 5.83829 4.43243ZM12.8471 4.4302C12.0381 4.43243 11.2086 4.83821 10.7744 5.36884C10.5504 5.64084 10.5322 5.87048 10.763 6.15587C11.7525 7.38657 13.7955 7.39549 14.7461 6.13134C14.8673 5.97081 14.8718 5.57841 14.753 5.41789C14.2731 4.76686 13.5715 4.47033 12.8471 4.4302Z" />
      </g>
      <defs>
        <clipPath id="clip0_548_4792">
          <rect
            width="16.5405"
            height="9.72973"
            transform="translate(0.973022 0.891846)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
